import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Loader2, Minus, Plus } from 'lucide-react';

const ServiceRequestForm = ({ serviceType, amenity, onSubmit, onCancel, loading }) => {
  const [quantity, setQuantity] = useState(1);
  const [notes, setNotes] = useState('');

  // Reset form when service changes
  useEffect(() => {
    setQuantity(1);
    setNotes('');
  }, [serviceType, amenity]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ 
      quantity, 
      notes,
      amenityId: amenity?.id 
    });
  };

  const increment = () => setQuantity(prev => Math.min(prev + 1, 10));
  const decrement = () => setQuantity(prev => Math.max(prev - 1, 1));

  const displayName = amenity ? amenity.name : serviceType;

  return (
    <form onSubmit={handleSubmit} className="space-y-6 mt-4">
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Quantity</Label>
          <div className="flex items-center space-x-4">
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={decrement}
              disabled={quantity <= 1 || loading}
            >
              <Minus className="w-4 h-4" />
            </Button>
            <span className="text-lg font-medium w-8 text-center">{quantity}</span>
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={increment}
              disabled={quantity >= 10 || loading}
            >
              <Plus className="w-4 h-4" />
            </Button>
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="notes">Additional notes (optional)</Label>
          <Textarea
            id="notes"
            placeholder={`Any specific instructions for your ${displayName.toLowerCase()} request?`}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            disabled={loading}
            className="resize-none text-foreground"
            rows={3}
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-4 border-t">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          disabled={loading}
          className="bg-[#923536] text-white shadow-sm hover:bg-[#7b2c2d] transition-all"
        >
          {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          Submit request
        </Button>
      </div>
    </form>
  );
};

export default ServiceRequestForm;